/**
 * The consultant's panel's place on the screen, in one place (navigation slice (d)): its width at each breakpoint, and
 * where a side sheet that stays beside the open panel ends (the parameter's limits sheet). Change one, change both: the
 * offset is the width. The panel covers the screen's width on a phone, where a sheet covers it as any sheet does.
 */
import { PANEL_ATTR } from "./selection";

/** The panel's width: 380px, 420px from xl. */
export const PANEL_WIDTH = "sm:w-[380px] xl:w-[420px]";

/** A sheet beside the open panel ends at the panel's edge: the panel's width from the right. */
export const BESIDE_PANEL = "sm:right-[380px] xl:right-[420px]";

/**
 * The "Ask the consultant" chip's layer (SelectionAsk): above a sheet (lib/ui/sheet SHEET_LAYER, z-40), which renders
 * inside the page's main content, so a selection in it (a parameter's limits) is askable and the chip must show over
 * it; under a dialog (z-50) and a toast (z-60).
 */
export const SELECTION_CHIP_LAYER = "z-[45]";

/** The panel itself, as a selector: an Escape pressed in it is the panel's, never a sheet's beside it. */
export const PANEL_SELECTOR = `[${PANEL_ATTR}]`;

/**
 * The width of an element's vertical scrollbar: what its box holds beyond its content and its two side borders. 0 for
 * an overlay scrollbar, which takes no room. Pure.
 */
export function scrollbarGutter(box: { offsetWidth: number; clientWidth: number; clientLeft: number }): number {
  return Math.max(0, box.offsetWidth - box.clientWidth - 2 * box.clientLeft);
}
